module.exports = __webpack_public_path__ + "static/media/BackgroundHome.88851f75.webp";